<template>
	<div>
		<!--面包屑导航区域-->
		<div class="crumbs">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>
					<i class="el-icon-s-custom"></i> 幼儿园关联绘本
				</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="container">
			<el-form :model="query" ref="query">
				<div class="handle-box">
					<el-row>
						<el-col :span="22">
							<div class="grid-content bg-purple">
								<!--搜索与添加-->
								<el-input v-model="query.name" clearable :placeholder="'请输入绘本名称'" class="handle-input mr10" style="width: 15%;"></el-input>
								
								<el-input v-model="query.code" clearable :placeholder="'请输入绘本条码'" class="handle-input mr10" style="width: 15%;"></el-input>
								
								<el-select v-model="query.valueSABSAAI" clearable filterable
								:placeholder="'请选择所属幼儿园'" class="handle-select mr10" style="width: 12%;" @change="getSAB(query.valueSABSAAI)">
								  <el-option
								  	v-for="item in query.optionsSABSAAI"
								  	:key="item.SAAMSID"
								  	:label="item.SAANAME"
								  	:value="item.SAAMSID">
								  </el-option>
								</el-select>
								
								<el-select v-model="query.valueSABMSID" clearable 
								:placeholder="'请选择班级名称'" class="handle-select mr10" style="width: 10%;" :disabled="HADSABIdisabled">
								  <el-option
								  	v-for="item in query.optionsSABMSID"
								  	:key="item.SABMSID"
								  	:label="item.SABNAME"
								  	:value="item.SABMSID">
								  </el-option>
								</el-select>
								
								<el-select  v-model="query.valueSTAT" clearable :placeholder="'请选择绘本状态'" class="select-shop mr10" style="width: 10%;">
									<el-option 
									 v-for="item in query.optionsSTAT" 
									 :key="item.INIKEY2" 
									 :label="item.INIDISP" 
									 :value="item.INIKEY2">
									</el-option>
								</el-select>
								
								
								
								
								
								<el-select v-model="query.value1" clearable filterable :placeholder="'请选择类型分类'" class="handle-select mr10"
								 style="width: 10%;" >
									<el-option v-for="item in query.optionsSORT1" :key="item.MTPMSID" :label="item.MTPNAME" :value="item.MTPMSID">
									</el-option>
								</el-select>
								
								<el-select v-model="query.value2" clearable filterable :placeholder="'请选择年龄分类'" class="handle-select mr10"
								 style="width: 10%;" >
									<el-option v-for="item in query.optionsSORT2" :key="item.MTPMSID" :label="item.MTPNAME" :value="item.MTPMSID">
									</el-option>
								</el-select>
								
								<el-select v-model="query.value3" clearable filterable :placeholder="'请选择出版社分类'" class="handle-select mr10"
								 style="width: 12%;" >
									<el-option v-for="item in query.optionsSORT3" :key="item.MTPMSID" :label="item.MTPNAME" :value="item.MTPMSID">
									</el-option>
								</el-select>
							</div>
						</el-col>
						<el-col :span="2">
							<div class="grid-content bg-purple-light">
								<el-button type="warning" :disabled="!hasPerms(buttonPerms.searchPerms)" class="float" icon="el-icon-search"
								 @click="handleSearch">搜索</el-button>
							</div>
						</el-col>
					</el-row>
					
					<el-row>
						<el-col :span="22">
							<div class="grid-content bg-purple">
								<div class="grid-content bg-purple">
									<el-button type="success" :disabled="!hasPerms(buttonPerms.exportPerms)"  @click="exportExcel">导出EXCEL</el-button>
								</div>
							</div>
						</el-col>
					</el-row>
				</div>
				<el-table :data="tableData" border class="table" 
				 header-cell-class-name="table-header"  :row-key="getRowKeys" v-loading="loading">
					<el-table-column type="index" :label="'序号'" width="80" align="center"></el-table-column>
					<el-table-column prop="MDANAME" :label="'绘本名称'" align="center"></el-table-column>
					<el-table-column prop="MDACODE" :label="'条码'" align="center"></el-table-column>
					
					<el-table-column prop="SAANAME" :label="'所在幼儿园'" align="center"></el-table-column>
					<el-table-column prop="SABNAME" :label="'所在班级'" align="center"></el-table-column>
					<el-table-column prop="INIDISP" :label="'绘本状态'" align="center"></el-table-column>
					
					<el-table-column prop="MTPNAME1" :label="'类型分类'" align="center"></el-table-column>
					<el-table-column prop="MTPNAME2" :label="'年龄分类'" align="center"></el-table-column>
					<el-table-column prop="MTPNAME3" :label="'出版社分类'" align="center"></el-table-column>
					

				</el-table>
				<div class="pagination">
					<el-pagination background layout="total, prev, pager, next, jumper,sizes" :current-page="this.query.pageIndex"
					:page-sizes="[10, 50,100]" :page-size="this.query.pageSize" :total="this.pageTotal" @size-change="handleSizeChange" @current-change="handlePageChange"></el-pagination>
				</div>
			</el-form>
		</div>
	</div>
</template>
<script>
	import {
		hasPermission
	} from '@/permission/index.js'
	export default {
		name: 'bookRelation',
		inject: ['reload'], //在子组件中通过inject调用
		data() {
			return {
				//页面按钮权限
				buttonPerms: {
					exportPerms: 'book:bookRelation:export', //导出权限标识
					addPerms: 'book:bookRelation:add', //新增权限标识
					searchPerms: 'book:bookRelation:search', //搜索权限标识
					editPerms: 'book:bookRelation:edit', //编辑权限标识
					deletePerms: 'book:bookRelation:delete', //删除权限标识

					disabled: false
				},

				web_suuid: sessionStorage.getItem("ms_web_suuid"),
				web_sphon: sessionStorage.getItem("ms_username"), //web 登录用户
				ms_role: sessionStorage.getItem("ms_role"), //web 权限
				HADSABIdisabled: true,
				query: {
					
					name: '',
					code: '',
					value1:'',
					value2:'',
					value3:'',
					optionsSORT1:[],
					optionsSORT2:[],
					optionsSORT3:[],
					
					
					valueSABSAAI:'', 	//幼儿园名称
					optionsSABSAAI: '',
					valueSABMSID:'', 	    //班级
					optionsSABMSID: '',
					valueSTAT:'', 	//绘本状态
					optionsSTAT: '',
					
					pageIndex: 1, //当前页
					pageSize: 10 //这是当前每页显示的条数
				},
				tableData: [],
				multipleSelection: [], // 多选操作
				delList: [],
				pageTotal: 0, // 总条数
				loading: false,
				typeAll: [],
				ULIDLabelNameFlag: true // 无跳转链接时删除输入框
			};
		},
		created() {
			let curpagenum = this.query.pageIndex; //当前页码
			this.getMTP('1');
			this.getMTP('2');
			this.getMTP('3');
			this.getSAA();
			this.getSTAT();
			this.getData(curpagenum); //获取当前列表数据
			this.GetMAAListCount(); //获取当前列表条数
		},
		mounted() {
			this.$bus.$on('change', () => {
				//刷新当前页面
				this.reload()
			})
		},
		methods: {

			getMTP(key) {
				const that = this;
				var postUrl = 'WCF/WEB/svcMAA.svc/GetMTPList';
				//网络请求接口
				this.$axios.post(
						//请求的url
						postUrl,
						//请求参数
						{
							sPHON: that.web_sphon, //web侧 登录ID  tihs.web_suuid
							sKEY:key
						}
					)
					.then((response) => {
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						if (resCount > 0) {
							if (key=='1')
							{
								this.query.optionsSORT1 = response.data.KKDT;
							}
							else if(key=='2')
							{
								this.query.optionsSORT2 = response.data.KKDT;
							}
							else if(key=='3')
							{
								this.query.optionsSORT3 = response.data.KKDT;
							}
						}
					})
					.catch((error) => {
						this.$message({
							message: '请求失败', //请求失败
							type: 'error'
						});
					});
			},

			hasPerms: function(perms) {
				// 根据权限标识和外部指示状态进行权限判断
				return hasPermission(perms) & !this.buttonPerms.disabled
			},
			// 日期格式化
			dateFormatter(row, column) {
				var t = new Date(row.HABBIRT); //row 表示一行数据, date 表示要格式化的字段名称
				var year = t.getFullYear(),
					month = t.getMonth() + 1,
					day = t.getDate();
				var newDate = year + '-' +
					(month < 10 ? '0' + month : month) + '-' +
					(day < 10 ? '0' + day : day);

				if (row.HABBIRT) {
					return newDate
				} else {
					return ''
				}
			},
			//获取班级名称
			getSAB(pSAAI) {
				const self_shop = this;
				self_shop.query.valueSABMSID = '';
				var postUrl = 'WCF/WEB/svcMBA.svc/GET_SAB_SABNAME';
				//网络请求接口
				this.$axios.post(
					//请求的url
					postUrl,
					//请求参数
					{
						sSAAI: pSAAI,
						sPHON: self_shop.web_sphon, //web侧 登录邮箱						
					}
				)
				.then((response) => {
					//请求成功返回的数据
					let resCount = response.data.KKDTCOUNT;
					if (resCount > 0) {
						this.query.optionsSABMSID = response.data.KKDT;
						this.HADSABIdisabled = false;
					}else{
						this.query.optionsSABMSID = [];
						this.HADSABIdisabled = true;
					}
				})
				.catch((error) => {
					this.$message({
						message: '获取班级名称失败',
						type: 'error'
					});
				});
			},		
			//获取幼儿园信息
			getSAA(){
				const self_agent = this;
				var postUrl='WCF/WEB/svcMAA.svc/Get_SAA_INI';
				//网络请求接口
				this.$axios.post(
					//请求的url
						postUrl,
					//请求参数
					{ 
						sPHON: self_agent.web_sphon, //web侧 登录ID  tihs.web_suuid
					}
				)
				.then((response) =>{
					//请求成功返回的数据
					let resCount = response.data.KKDTCOUNT;
					if(resCount>0){
						this.query.optionsSABSAAI = response.data.KKDT;
					}		
				})
				.catch((error) =>{
					this.$message({
					  message: '获取幼儿园信息请求失败',  
					  type: 'error'
					});
				});	
			},
			//获取绘本状态
			getSTAT() {
				const self_shop = this;
				var postUrl = 'WCF/WEB/svcINI.svc/Get_INI_List';
				//网络请求接口
				this.$axios.post(
					//请求的url
					postUrl,
					//请求参数
					{
						sPHON: self_shop.web_sphon, //web侧 登录邮箱
						sINIKEY1: 10019
					}
				)
				.then((response) => {
					//请求成功返回的数据
					let resCount = response.data.KKDTCOUNT;
					if (resCount > 0) {
						this.query.optionsSTAT = response.data.KKDT;
					}
				})
				.catch((error) => {
					this.$message({
						message: '获取绘本状态失败', 
						type: 'error'
					});
				});
			},
			
			// 获取当前列表条数
			GetMAAListCount() {
				const self_count = this;
				var postUrl = 'WCF/WEB/svcMAA.svc/GetMAAListCount';
				//网络请求接口
				this.$axios.post(
						//请求的url
						postUrl,
						//请求参数
						{
							sPHON: self_count.web_sphon, //web侧 登录ID  tihs.web_suuid
							sNAME: self_count.query.name.trim(),
							sCODE: self_count.query.code.trim(),
							sSAAI: self_count.query.valueSABSAAI,
							sSABI: self_count.query.valueSABMSID,
							sSTAT: self_count.query.valueSTAT,
							sLSFL: self_count.query.value1,
							sNLFL: self_count.query.value2,
							sCBFL: self_count.query.value3,
						}
					)
					.then((response) => {
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						this.pageTotal = Number(resCount); //总条数
					})
					.catch((error) => {
						this.$message({
							message: '获取绘本信息失败', //请求失败
							type: 'error'
						});
					});
			},
			// 获取用户数据
			getData(curpage) {
				this.loading = true; //初始化加载loading效果
				const self_count = this;
				var postUrl = 'WCF/WEB/svcMAA.svc/GetMAAList';
				//网络请求接口
				this.$axios.post(
						//请求的url
						postUrl,
						//请求参数
						{
							sPHON: self_count.web_sphon, //web侧 登录ID  tihs.web_suuid
							sPageIndex: curpage, //页码
							sPageSize: self_count.query.pageSize, //每页显示条数
							sNAME: self_count.query.name.trim(),
							sCODE: self_count.query.code.trim(),
							
							sSAAI: self_count.query.valueSABSAAI,
							sSABI: self_count.query.valueSABMSID,
							sSTAT: self_count.query.valueSTAT,
							
							sLSFL: self_count.query.value1,
							sNLFL: self_count.query.value2,
							sCBFL: self_count.query.value3,
						})
					.then((response) => {
						this.loading = false; //取消loading效果
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						let resKKDT = response.data.KKDT;
						if (resCount > 0) {
							//渲染数据 List
							this.tableData = resKKDT; //数据数组
						} else {
							this.tableData = []; //数据数组
						}
					})
					.catch((error) => {
						this.loading = false; //取消loading效果
						this.$message({
							message: '获取绘本信息失败', //请求失败
							type: 'error'
						});
					});

			},
			// 触发搜索按钮
			handleSearch() {
				this.$set(this.query, 'pageIndex', 1);

				this.getData(1);
				this.GetMAAListCount(); //获取当前列表条数
			},
			// 触发打印
			exportExcel() {
				const self_count = this;
				var postUrl = 'WCF/WEB/svcMAA.svc/ExportMAAList';
				//网络请求接口
				this.$axios.post(
					//请求的url
					postUrl,
					//请求参数
					{
						sPHON: self_count.web_sphon, //web侧 登录ID  tihs.web_suuid
						sNAME: self_count.query.name.trim(),
						sCODE: self_count.query.code.trim(),
						
						sSAAI: self_count.query.valueSABSAAI,
						sSABI: self_count.query.valueSABMSID,
						sSTAT: self_count.query.valueSTAT,
						
						sLSFL: self_count.query.value1,
						sNLFL: self_count.query.value2,
						sCBFL: self_count.query.value3,
					})
				.then((response) => {
					console.log(response)
					let restr=response.data.ExportMAAListResult;
					if (restr!='')
					{
						window.open(this.basehtmlURL + restr);
					}else{
						this.$message({
							message: '导出失败', //请求失败
							type: 'error'
						});
						
					}
				})
				.catch((error) => {
					this.$message({
						message: '请求失败', //请求失败
						type: 'error'
					});
				});
			},
			// 触发新增按钮
			handleAdd() {
				this.$router.push('/addBook'); // 跳转路由
			},
			// 查看操作
			handleView(index, row){
				this.idx = index;
				// 跳转路由
				this.$router.push({
					name: 'editBook',
					query: {
						MDAMSID: row.MDAMSID,
						flag: 'view'
					}
				})
			},

			// 分页导航 currentPage 改变时会触发
			handlePageChange(currentPage) {
				this.$set(this.query, 'pageIndex', currentPage);
				// 调取列表的函数，初始化时调一次
				this.getData(currentPage);
			},
			//pageSize 改变时会触发
			handleSizeChange(size) {
				this.$set(this.query, 'pageIndex', 1);
				this.$set(this.query, 'pageSize', size);
				// 调取列表的函数，初始化时调一次
				this.getData(1);
			},
			getRowKeys(row) {
				return row.MAAMSID; // id为列表数据的唯一标识
			},

		}
	};
</script>
<style scoped>
	.handle-box {
		margin-bottom: 20px;
	}

	.handle-select {
		width: 12%;
	}


	.table {
		width: 100%;
		font-size: 14px;
	}

	.red {
		color: #ff0000;
	}

	.black {
		color: #000000;
	}

	.mr10 {
		margin-right: 10px;
	}

	.table-td-thumb {
		display: block;
		margin: auto;
		width: 40px;
		height: 40px;
	}

	.select-shop {
		width: 16%;
	}

	.select-agent {
		width: 14%;
	}

	.el-row {
		margin-top: 15px;
	}

	.bg-purple {
		text-align: left;
	}

	.bg-purple-light {
		text-align: right;
	}

	.grid-content {
		min-height: 34px;
	}

	.handle-input {
		width: 250px;
	}

	.el-input--small .el-input__inner {
		height: 36px;
		line-height: 36px;
		font-size: 14px;
	}

	.el-upload--text {
		width: 140px;
		height: 80px;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 140px;
		height: 80px;
		line-height: 80px;
		text-align: center;
	}

	.avatar {
		width: 140px;
		height: 80px;
		display: block;
	}

	.el-dialog__footer {
		text-align: center;
	}

	.dialog-footer-btn {
		margin-right: 20px;
	}

	.cropper {
		width: auto;
		height: 300px;
	}
</style>
